import ContentTypeButton from './ContentTypeButton';
import IconButton from '../../../components/atoms/button/IconButton';
import { ContentType } from '../../../types/contentTypes';

import './ContentTypeChooser.scss';

interface ContentTypeChooserProps {
  value?: ContentType;
  onSelect?: (selectedType: ContentType | undefined) => void;
  onDelete?: () => void;
  disabled?: boolean;
  className?: string;
}

export default function ContentTypeChooser({
  value,
  onSelect,
  onDelete,
  disabled = false,
  className = '',
}: ContentTypeChooserProps) {
  function getVisualType(type: ContentType): 'primary' | 'secondary-blue-text' {
    return `${type === value ? 'secondary-blue-text' : 'primary'}`;
  }

  function handleClick(selectedType: ContentType) {
    if (disabled) return;
    if (selectedType !== value) {
      onSelect?.(selectedType);
    }
  }

  return (
    <div className={`content-type-chooser ${className}`}>
      <ContentTypeButton
        label="Video"
        selected={value === ContentType.Video}
        icon="play-circle-outline"
        disabled={disabled && value !== ContentType.Video}
        onSelect={() => handleClick(ContentType.Video)}
        onDelete={onDelete}
      />
      <ContentTypeButton
        label="Text"
        selected={value === ContentType.Text}
        icon="text-snippet-outline"
        disabled={disabled && value !== ContentType.Text}
        onSelect={() => handleClick(ContentType.Text)}
        onDelete={onDelete}
      />
      <IconButton
        label={'Image'}
        visualType={getVisualType(ContentType.InteractiveImage)}
        orientation="column"
        iconSize="lg"
        icon="photo-camera-outline"
        disabled={disabled && value !== ContentType.InteractiveImage}
        onClick={() => handleClick(ContentType.InteractiveImage)}
      />
      <ContentTypeButton
        label="Quiz"
        selected={value === ContentType.Quiz}
        icon="quiz-outline"
        disabled={disabled && value !== ContentType.Quiz}
        onSelect={() => handleClick(ContentType.Quiz)}
        onDelete={onDelete}
      />
      <ContentTypeButton
        label="Text Survey"
        selected={value === ContentType.TextSurvey}
        icon="pie-chart-outline"
        disabled={disabled && value !== ContentType.TextSurvey}
        onSelect={() => handleClick(ContentType.TextSurvey)}
        onDelete={onDelete}
      />
      <ContentTypeButton
        label="Select Survey"
        selected={value === ContentType.SelectSurvey}
        icon="checklist"
        disabled={disabled && value !== ContentType.SelectSurvey}
        onSelect={() => handleClick(ContentType.SelectSurvey)}
        onDelete={onDelete}
      />
      <ContentTypeButton
        label="PDF"
        selected={value === ContentType.Pdf}
        icon="file-open-outline-rounded"
        disabled={disabled && value !== ContentType.Pdf}
        onSelect={() => handleClick(ContentType.Pdf)}
        onDelete={onDelete}
      />
    </div>
  );
}
